import React, { PureComponent } from "react";
import KBELogo from "../img/kbe-Logo-66454.png";
import { Link } from "react-router-dom";
import queryString from "query-string";
import { Alert } from "reactstrap";
import KeyVariantIcon from "mdi-react/KeyVariantIcon";
import AppConfig from "../../../config/appconfig.json";

class ResetPassword extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isSuccess: false,
      password: "",
      confirmpassword: "",
      isHashValid: false,
      hash: "",
      isLoading: false,
      isError: false,
      errorMsg: ""
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleResetPassword = this.handleResetPassword.bind(this);
  }

  componentDidMount() {
    const values = queryString.parse(this.props.location.search);
    // console.log(values.hash);
    if (values.hash) {
      this.setState({ isHashValid: true, hash: values.hash });
    }
  }

  handleResetPassword(e) {
    if (this.state.password !== this.state.confirmpassword) {
      this.setState({
        isError: true,
        errorMsg: "New password and confirm password do not match."
      });
    } else {
      this.setState({ isError: false, isLoading: true });
      const queryStringParam =
        "hash=" +
        this.state.hash +
        "&password=" +
        this.state.password +
        "&passwordConfirm=" +
        this.state.confirmpassword;

      let isResetPasswordFailed = false;
      fetch(
        `${AppConfig.BACK_END_URL}/APIClient/ResetPassword?` + queryStringParam
      )
        .then(response => {
          if (response.ok === false) {
            isResetPasswordFailed = true;
          }
          return response.json();
        })
        .then(json => {
          if (isResetPasswordFailed) {
            const respObj = JSON.parse(json);
            this.setState({
              isError: true,
              errorMsg: respObj.Message,
              isLoading: false
            });
          } else {
            this.setState({ isLoading: false, isSuccess: true });
          }
        })
        .catch(() => {
          this.setState({
            isError: true,
            errorMsg:
              "Something went wrong when resetting your password. Please try again.",
            isLoading: false
          });
        });
    }
    e.preventDefault();
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  render() {
    return (
      <div className="account">
        <div className="account__wrapper">
          <div className="account__card">
            <div className="account__head">
              <img src={KBELogo} alt="logo" />
              {this.state.isSuccess ? (
                <p>Your password has been reset successfully</p>
              ) : (
                <div>
                  {this.state.isHashValid ? (
                    <p>Now, please insert your new password.</p>
                  ) : (
                    <p>Error! Page not found.</p>
                  )}
                </div>
              )}
            </div>
            {this.state.isSuccess ? (
              <div />
            ) : (
              <div>
                {this.state.isHashValid ? (
                  <div>
                    {this.state.isError ? (
                      <Alert color="danger">
                        <div className="alert__content">
                          <p>
                            <span className="bold-text">Error!</span>{" "}
                            {this.state.errorMsg}
                          </p>
                        </div>
                      </Alert>
                    ) : (
                      <div />
                    )}
                    <form className="form" onSubmit={this.handleResetPassword}>
                      <div className="form__form-group">
                        <label className="form__form-group-label">
                          New Password
                        </label>
                        <div className="form__form-group-field">
                          <div className="form__form-group-icon">
                            <KeyVariantIcon />
                          </div>
                          <input
                            type="password"
                            name="password"
                            placeholder="New Password"
                            onChange={this.handleInputChange}
                            required
                          />
                        </div>
                      </div>
                      <div className="form__form-group">
                        <label className="form__form-group-label">
                          Confirm Password
                        </label>
                        <div className="form__form-group-field">
                          <div className="form__form-group-icon">
                            <KeyVariantIcon />
                          </div>
                          <input
                            type="password"
                            name="confirmpassword"
                            placeholder="Confirm Password"
                            onChange={this.handleInputChange}
                            required
                          />
                        </div>
                      </div>
                      <input
                        type="submit"
                        className="btn btn-primary account__btn"
                        value="Reset Password"
                        disabled={this.state.isLoading}
                      />
                    </form>
                  </div>
                ) : (
                  <div />
                )}
              </div>
            )}
            <div className="account__have-account">
              <p>
                Back to homepage? <Link to="/">Login</Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ResetPassword;



// WEBPACK FOOTER //
// ./src/pages/account/reset_pass/ResetPassword.js